/**
 * Buchungsziel-Auswahl der Zeiterfassung (TimeTrackingPage, QuickTimeEntryDialog).
 * Eine Regel für beide Formulare.
 */

/** Bis zu fünf zuletzt bebuchte Kunden-IDs des Users (Einträge nach Datum absteigend). */
export const recentCustomerIds = (entries, userId) =>
  [...new Set((entries || [])
    .filter((e) => userId == null || e.user_id === userId)
    .map((e) => e.customer_id)
    .filter(Boolean))].slice(0, 5);

/** Zuletzt bebuchte Kunden zuerst, danach der Rest in bisheriger Reihenfolge. */
export const sortCustomersByRecent = (customers, recentIds) => [
  ...recentIds.map((id) => customers.find((c) => c.id === id)).filter(Boolean),
  ...customers.filter((c) => !recentIds.includes(c.id)),
];

/** Tasks in Tickets und reine Zeiterfassungs-Tasks trennen. */
export const splitTasks = (tasks) => ({
  tickets: (tasks || []).filter((t) => !t.is_timetracker_only),
  tracker: (tasks || []).filter((t) => t.is_timetracker_only),
});

/**
 * Nur die Antwort der jüngsten Anfrage durchlassen. Wechselt man schnell den
 * Kunden, würde sonst eine langsame alte Task-Liste die neue überschreiben.
 * Ältere Antworten bleiben einfach unbeantwortet.
 */
export const latestOnly = () => {
  let seq = 0;
  return (promise) => {
    const id = ++seq;
    return promise.then((value) => (id === seq ? value : new Promise(() => {})));
  };
};
